module.exports = __webpack_public_path__ + "img/3_108.e66d61ef.png";